'use strict';

module.exports = angular.module('superdostavka.labels', [])
    .factory('labelsManager', ['$http', 'posManager', function($http, posManager) {
        var labelsManager = {

            positionsLabels: false,
            config_promise: null,
            filters: null,
            hasActive: null,
            activeFilters: null,
            activePositions: false,
            activeSections: false,

            getConfig: function() {
                if(!this.config_promise)
                    this.config_promise = $http.get('/labels_api/get')

                return this.config_promise;
            },
            filterLabel: function(filter) {
                filter.active = !filter.active;

                for(var i in this.filters)
                {
                    if(filter != this.filters[i])
                        this.filters[i].active = false;
                }

                var hasActive = false;
                var activeFilters = [];
                var activePositions = {};
                var activeSections = {};

                for(var j in this.filters)
                {
                    if(this.filters[j].active)
                    {
                        hasActive = true;
                        activeFilters.push(this.filters[j]);
                    }
                }

                this.hasActiveFilter = hasActive;
                this.activeFilters = activeFilters;

                for(var i in posManager.sections)
                    activeSections[posManager.sections[i].id] = false;

                if(hasActive)
                {
                    for(var i in posManager.positions)
                        activePositions[posManager.positions[i].id] = false;

                    for(var j in activeFilters)
                    {
                        for(var i in this.positionsLabels)
                        {
                            for(var k in this.positionsLabels[i])
                            {
                                if(this.positionsLabels[i][k].id == activeFilters[j].id)
                                {
                                    var pos_id = this.positionsLabels[i][k].position_id;
                                    activePositions[pos_id] = true;
                                    activeSections[posManager.getPosition(pos_id).section_id] = true;
                                }
                            }
                        }
                    }
                } else
                {
                    for(var i in posManager.positions)
                        activePositions[posManager.positions[i].id] = true;

                    for(var i in posManager.sections)
                        activeSections[posManager.sections[i].id] = true;
                }

                this.activePositions = activePositions;
                this.activeSections = activeSections;
            }
        };

        return labelsManager;
    }])
    .filter('posLabelFilter', ['labelsManager', function(labelsManager) {
      return function(id) {

        if(labelsManager.activePositions == false)
            return true;

        return labelsManager.activePositions[id];
      };
  }])
    .filter('sectionLabelFilter', ['labelsManager', function(labelsManager) {
      return function(id) {

        if(labelsManager.activePositions == false)
            return true;

        return labelsManager.activeSections[id];
      };
  }])
    .controller('labelsCtrl', ['$scope', 'labelsManager', function($scope, labelsManager) {

        $scope.labelsManager = labelsManager;

        var handleSuccess = function(data, status) {
            $scope.labelsManager.positionsLabels = data.positions_labels;
            $scope.labelsManager.filters = data.filters;
        };

        $scope.getPositionLabels = function(id) {
            return $scope.labelsManager.positionsLabels['position_'+id];
        };

        $scope.isHex = function(value) {
            return /#/.test(value);
        };

        $scope.filterLabel = function(filter) {
            $scope.labelsManager.filterLabel(filter);
        }

        if(!$scope.labelsManager.positionsLabels)
            $scope.labelsManager.getConfig().success(handleSuccess);
    }])
;
